/* Nathr carousels: arrow scrolling and mouse drag for every .nathr-rail on the page.
   Touch swipe is handled natively by the rail's own overflow-x scrolling. */
(function () {
  'use strict';

  var DRAG_THRESHOLD = 5;
  var GAP = 24;

  function stepFor(rail) {
    // Scroll by roughly one screenful of cards, never less than one card.
    var first = rail.firstElementChild;
    var card = first ? first.getBoundingClientRect().width + GAP : 0;
    return Math.max(card, rail.clientWidth * 0.6) || rail.clientWidth || 200;
  }

  function isRtl(el) {
    return getComputedStyle(el).direction === 'rtl';
  }

  /* Arrows live in the section header, outside the rail, so the id in
     data-target is the primary link. Falling back to the section's own rail
     keeps the arrows working if that id is ever renamed or duplicated. */
  function railFor(btn) {
    var rail = btn.dataset.target ? document.getElementById(btn.dataset.target) : null;
    if (rail) return rail;
    var section = btn.closest('.shopify-section, section');
    return section ? section.querySelector('.nathr-rail') : null;
  }

  function canScroll(rail) {
    return rail.scrollWidth - rail.clientWidth > 1;
  }

  function scrollRail(rail, sign) {
    var delta = sign * stepFor(rail);
    // scrollLeft runs 0 -> -max under RTL, so forward is a negative delta there.
    if (isRtl(rail)) delta = -delta;

    try {
      rail.scrollBy({ left: delta, behavior: 'smooth' });
    } catch (e) {
      // Older engines reject the options object; the CSS scroll-behavior still smooths this.
      rail.scrollLeft += delta;
    }
  }

  /* One delegated listener covers every arrow on the page, including sections
     the theme editor injects after load. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-nathr-scroll]') : null;
    if (!btn) return;

    var rail = railFor(btn);
    if (!rail || !canScroll(rail)) return;

    event.preventDefault();
    scrollRail(rail, btn.dataset.nathrScroll === 'next' ? 1 : -1);
  });

  /* Arrows that cannot move the rail any further are dimmed, so a dead-looking
     arrow always means "end of track" rather than "script is broken". */
  function syncArrows(rail) {
    var section = rail.closest('.shopify-section, section');
    if (!section) return;

    var atStart = Math.abs(rail.scrollLeft) < 2;
    var atEnd = Math.abs(rail.scrollLeft) + rail.clientWidth >= rail.scrollWidth - 2;
    var idle = !canScroll(rail);

    section.querySelectorAll('[data-nathr-scroll]').forEach(function (btn) {
      if (railFor(btn) !== rail) return;
      var next = btn.dataset.nathrScroll === 'next';
      // aria-disabled, not the disabled property: a disabled button stops firing
      // clicks, so a bad measurement would look exactly like the dead arrows
      // this replaces. The click handler stays live and decides for itself.
      btn.setAttribute('aria-disabled', idle || (next ? atEnd : atStart) ? 'true' : 'false');
    });
  }

  function bindDrag(rail) {
    if (rail.dataset.nathrDragBound) return;
    rail.dataset.nathrDragBound = '1';
    rail.style.cursor = 'grab';

    syncArrows(rail);
    rail.addEventListener('scroll', function () {
      syncArrows(rail);
    });
    window.addEventListener('resize', function () {
      syncArrows(rail);
    });

    var dragging = false;
    var startX = 0;
    var startScroll = 0;
    var distance = 0;

    rail.addEventListener('pointerdown', function (event) {
      // Touch and pen keep the browser's native momentum scrolling.
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      dragging = true;
      distance = 0;
      startX = event.clientX;
      startScroll = rail.scrollLeft;
      rail.style.cursor = 'grabbing';
      // Snapping fights a free drag; restored on release.
      rail.style.scrollSnapType = 'none';
    });

    rail.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var dx = event.clientX - startX;
      distance = Math.abs(dx);
      if (distance > DRAG_THRESHOLD && rail.setPointerCapture) {
        try {
          rail.setPointerCapture(event.pointerId);
        } catch (e) {
          /* capture is best-effort */
        }
      }
      rail.scrollLeft = startScroll - dx;
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      rail.style.cursor = 'grab';
      rail.style.scrollSnapType = '';

      // A drag must not also activate the card link it started on.
      if (distance > DRAG_THRESHOLD) {
        var swallow = function (event) {
          event.preventDefault();
          event.stopPropagation();
        };
        rail.addEventListener('click', swallow, { capture: true, once: true });
        setTimeout(function () {
          rail.removeEventListener('click', swallow, true);
        }, 50);
      }
    }

    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);
    rail.addEventListener('pointerleave', endDrag);
    rail.addEventListener('dragstart', function (event) {
      if (dragging) event.preventDefault();
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.nathr-rail').forEach(bindDrag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  // Images settle after load and change the rail's scrollWidth.
  window.addEventListener('load', function () {
    document.querySelectorAll('.nathr-rail').forEach(syncArrows);
  });
})();
